import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Tabs } from '@shared/components/MaterialUIEnhancements/Tabs'
import { Content } from '@shared/layouts'
import { NavigationTabLink } from 'components/LinkedMUIComponents/NavigationTabLink'
import { ActionsMenu } from 'domains/Organizations/Organization/TeamManagement/Team/ActionsMenu'
import { useTeamUpdateMutation } from 'hooks/mutations/org/Team'
import {
  teamRoute,
  teamOverviewRoute,
  membersOverviewRoute,
} from 'pages/NWPlatform/Organizations/Organization/Teams/Team'
import { teamQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['pages', 'entity'])

  const { teamId } = teamRoute.useParams()

  const teamQuery = useQuery(teamQueryKeys.detail({ teamId }))
  const { data: team } = teamQuery

  const { mutate: updateTeam, ...teamUpdateMutation } = useTeamUpdateMutation()

  const handleUpdateTeamName = useCallback(
    (title: string, closeCallback: () => void) => {
      if (team) {
        updateTeam(
          {
            teamId,
            orgTeamEdit: {
              name: title,
            },
          },
          {
            onSettled: closeCallback,
          },
        )
      }
    },
    [team, teamId, updateTeam],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={teamQuery.data?.name ?? ''}
          isLoading={teamQuery.isLoading}
          isSaving={teamUpdateMutation.isPending}
          onSave={handleUpdateTeamName}
          TabNavigation={
            <Tabs>
              <NavigationTabLink from={teamRoute.fullPath} to={membersOverviewRoute.to}>
                {t('pages:My.users')}
              </NavigationTabLink>
              <NavigationTabLink from={teamRoute.fullPath} to={teamOverviewRoute.to}>
                {t('pages:My.teams')}
              </NavigationTabLink>
            </Tabs>
          }
          Actions={<ActionsMenu />}
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
